import {
  Component,
  OnInit,
  AfterContentInit,
  ContentChildren,
  QueryList,
  ViewEncapsulation,
  HostBinding,
  NgZone,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PgListSelectItemComponent } from './pg-list-select-item/pg-list-select-item.component';
import { ChildEventChannel } from '../core/events/child-event-channel';

@Component({
  selector: 'pg-list-select, grit-list-select',
  templateUrl: './pg-list-select.component.html',
  styleUrls: ['./pg-list-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PgListSelectComponent,
      multi: true,
    },
    ChildEventChannel,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PgListSelectComponent
  implements OnInit, ControlValueAccessor, AfterContentInit {
  @ContentChildren(PgListSelectItemComponent)
  _itemChildren: QueryList<PgListSelectItemComponent>;

  value: any;
  disabled;
  protected _onChange = _ => {};
  protected _onTouch = _ => {};
  constructor(
    public eventChannel: ChildEventChannel,
    private _ngZone: NgZone
  ) {}
  @HostBinding('attr.role') _role = 'listbox';
  @HostBinding('attr.aria-multiselectable') _ariaMultiSelectable = false;

  ngOnInit() {
    this.eventChannel.events.subscribe((data: PgListSelectItemComponent) => {
      this.writeValue(data.value);
    });
  }

  ngAfterContentInit() {
    this._ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        this._setActiveChild(this._getItemWithValue(this.value));
      })
    );
  }

  private _getItemWithValue(val) {
    if (!this._itemChildren) {
      return null;
    }
    return this._itemChildren.find(c => c.value === val);
  }

  private _setActiveChild(item: PgListSelectItemComponent) {
    if (!this._itemChildren) {
      return;
    }
    this._itemChildren.forEach(child => {
      if (child !== item) {
        child.active = false;
      }
    });
    if (!item) {
      return;
    }
    item.active = true;
  }

  writeValue(obj: any): void {
    this.value = obj;
    this._setActiveChild(this._getItemWithValue(this.value));
    this._onChange(obj);
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
